import script from "./biz-table-set-field.vue?vue&type=script&lang=tsx&setup=true"
export * from "./biz-table-set-field.vue?vue&type=script&lang=tsx&setup=true"

import "./biz-table-set-field.vue?vue&type=style&index=0&id=279e078c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-279e078c"]])

export default __exports__